import * as React from 'react';
import { useTranslation } from 'next-i18next';

import { useNavigationContext } from '@restworld/utils-common';
import { ArrowLeftIcon, GlobeAltIcon } from '@heroicons/react/24/outline';
import { Button, Heading } from '@restworld/ui-ds-base';
import { JobFavoritePositionButton, JobFavoritePositionButtonProps } from '../job-favorite-position-modal';

type PageInsiderNavProps = JobFavoritePositionButtonProps & { isJobPositionOutsideItaly?: boolean };
export const PageInsiderNav: React.FunctionComponent<PageInsiderNavProps> = ({
  isJobPositionOutsideItaly,
  ...rest
}) => {
  const { router } = useNavigationContext();
  const { t } = useTranslation('job-position-page');
  return (
    <div className="w-full bg-white lg:p-0">
      <div className="flex justify-between w-full">
        <Button
          variant="tertiary"
          className="!shadow-none"
          StartIcon={ArrowLeftIcon}
          onClick={() => router?.push('/cerco-lavoro')}
        />
        <Heading
          as="span"
          size={6}
          weight="semibold"
          testId="job-position-title"
          className="inline-flex items-center gap-1"
        >
          {t('job_title')}
          {isJobPositionOutsideItaly && <GlobeAltIcon className="h-4 w-4" />}
        </Heading>
        <JobFavoritePositionButton {...rest} />
      </div>
    </div>
  );
};
